import React from "react";
import { Link } from "react-router-dom";

export default function TermsOfService() {
  const sectionStyle = { marginBottom: 28 };
  const h2Style = { fontSize: 20, fontWeight: 800, marginBottom: 10, color: "#1a1a1a" };
  const pStyle = { fontSize: 15, lineHeight: 1.7, color: "#444", marginBottom: 10 };
  const ulStyle = { paddingLeft: 24, marginBottom: 10 };
  const liStyle = { fontSize: 15, lineHeight: 1.7, color: "#444", marginBottom: 6 };

  return (
    <div style={{ maxWidth: 800, margin: "0 auto", padding: "40px 20px" }}>
      <div style={{ marginBottom: 30 }}>
        <Link to="/" style={{ color: "#dc2626", textDecoration: "none", fontWeight: 700, fontSize: 20 }}>
          RoadOptix
        </Link>
      </div>

      <h1 style={{ fontSize: 32, fontWeight: 900, marginBottom: 8, color: "#111" }}>Terms of Service</h1>
      <p style={{ fontSize: 14, color: "#888", marginBottom: 30 }}>Last Updated: February 26, 2026</p>

      <div style={sectionStyle}>
        <h2 style={h2Style}>1. Acceptance of Terms</h2>
        <p style={pStyle}>
          By accessing or using the RoadOptix platform ("Service") operated by Symple Code Business Systems, LLC 
          ("Company", "we", "us"), you agree to be bound by these Terms of Service ("Terms"). If you do not 
          agree to these Terms, do not use the Service.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={h2Style}>2. Description of Service</h2>
        <p style={pStyle}>
          RoadOptix is a transportation management system (TMS) that provides freight brokerage tools, 
          carrier management, load matching, bidding, GPS tracking, document management, factoring services, 
          and related logistics technology services. The platform connects freight brokers, carriers, and shippers.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={h2Style}>3. User Accounts</h2>
        <ul style={ulStyle}>
          <li style={liStyle}>You must provide accurate and complete registration information</li>
          <li style={liStyle}>You are responsible for maintaining the confidentiality of your account credentials</li>
          <li style={liStyle}>You are responsible for all activities that occur under your account</li>
          <li style={liStyle}>You must notify us immediately of any unauthorized use of your account</li>
          <li style={liStyle}>Carriers must maintain valid MC/DOT numbers and comply with all FMCSA regulations</li>
        </ul>
      </div>

      <div style={sectionStyle}>
        <h2 style={h2Style}>4. Carrier Obligations</h2>
        <p style={pStyle}>Carriers using the platform agree to:</p>
        <ul style={ulStyle}>
          <li style={liStyle}>Maintain active operating authority and required insurance</li>
          <li style={liStyle}>Comply with all federal, state, and local transportation regulations</li>
          <li style={liStyle}>Provide accurate equipment and availability information</li>
          <li style={liStyle}>Honor accepted bids and tenders in good faith</li>
          <li style={liStyle}>Provide timely status updates and GPS tracking when required</li>
          <li style={liStyle}>Deliver shipments in accordance with agreed-upon terms</li>
        </ul>
      </div>

      <div style={sectionStyle}>
        <h2 style={h2Style}>5. Broker Obligations</h2>
        <p style={pStyle}>Brokers using the platform agree to:</p>
        <ul style={ulStyle}>
          <li style={liStyle}>Maintain valid broker authority and surety bond</li>
          <li style={liStyle}>Provide accurate load information including weight, dimensions, and requirements</li>
          <li style={liStyle}>Process payments in accordance with agreed-upon terms</li>
          <li style={liStyle}>Comply with all applicable transportation brokerage regulations</li>
        </ul>
      </div>

      <div style={sectionStyle}>
        <h2 style={h2Style}>6. Bidding and Contracts</h2>
        <p style={pStyle}>
          Bids submitted through the platform constitute binding offers. When a broker awards a bid, 
          it creates a binding agreement between the broker and carrier for the transportation of the 
          specified load at the agreed-upon rate. Cancellation terms and penalties may apply as specified 
          in individual load terms.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={h2Style}>7. Payments and Factoring</h2>
        <p style={pStyle}>
          Payment terms are as specified in individual agreements between brokers and carriers. 
          Quick Pay / factoring services are subject to additional terms and fees as disclosed 
          at the time of request. We are not a bank or financial institution and factoring services 
          are provided as a convenience feature of the platform.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={h2Style}>8. SMS Communications</h2>
        <p style={pStyle}>
          By providing your phone number and opting in to SMS notifications, you consent to receive 
          text messages from RoadOptix related to load alerts, backhaul matches, status updates, and 
          account notifications. Standard message and data rates may apply. You can opt out at any 
          time by replying STOP. See our <Link to="/sms-consent" style={{ color: "#dc2626" }}>SMS Terms</Link> for 
          complete details.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={h2Style}>9. Intellectual Property</h2>
        <p style={pStyle}>
          The Service, including its design, features, algorithms (including AI load matching), and content, 
          is owned by Symple Code Business Systems, LLC and is protected by intellectual property laws. 
          You may not copy, modify, distribute, or reverse engineer any part of the Service.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={h2Style}>10. Limitation of Liability</h2>
        <p style={pStyle}>
          THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND. WE ARE NOT LIABLE FOR ANY 
          INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING FROM YOUR USE OF 
          THE SERVICE. OUR TOTAL LIABILITY SHALL NOT EXCEED THE AMOUNT PAID BY YOU IN THE 12 MONTHS 
          PRECEDING THE CLAIM. WE ARE NOT A PARTY TO TRANSPORTATION CONTRACTS BETWEEN BROKERS AND 
          CARRIERS AND ARE NOT LIABLE FOR CARGO LOSS, DAMAGE, OR DELAYS.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={h2Style}>11. Indemnification</h2>
        <p style={pStyle}>
          You agree to indemnify and hold harmless Symple Code Business Systems, LLC from any claims, 
          damages, losses, or expenses arising from your use of the Service or violation of these Terms.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={h2Style}>12. Termination</h2>
        <p style={pStyle}>
          We may suspend or terminate your account at any time for violation of these Terms or for any 
          reason at our discretion. Upon termination, your right to use the Service ceases immediately. 
          Data retention after termination is governed by our Privacy Policy.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={h2Style}>13. Governing Law</h2>
        <p style={pStyle}>
          These Terms are governed by the laws of the State of Texas without regard to conflict of law 
          principles. Any disputes shall be resolved in the courts of Harris County, Texas.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={h2Style}>14. Changes to Terms</h2>
        <p style={pStyle}>
          We reserve the right to modify these Terms at any time. Continued use of the Service after 
          changes constitutes acceptance of the updated Terms.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={h2Style}>15. Contact Us</h2>
        <p style={pStyle}>
          <strong>Symple Code Business Systems, LLC</strong><br />
          Houston, TX<br />
          Email: legal@roadoptix.com<br />
          Phone: (346) 224-0790
        </p>
      </div>

      <div style={{ borderTop: "1px solid #eee", paddingTop: 20, marginTop: 40, fontSize: 13, color: "#888" }}>
        <Link to="/terms" style={{ color: "#888", marginRight: 20 }}>Terms of Service</Link>
        <Link to="/sms-consent" style={{ color: "#888", marginRight: 20 }}>SMS Terms</Link>
        <Link to="/privacy" style={{ color: "#888" }}>Privacy Policy</Link>
      </div>
    </div>
  );
}
